<template>
  <div
    ref="activeMatchItem"
    class="m-match-item-wrap"
    :class="{
      active: isActive
    }"
    @click="handleClick"
  >
    <div class="m-match-item">
      <div class="m-teams">
        <div class="m-teams--info">
          <div class="m-team-name m-home-team">
            {{ event.homeTeam }}
          </div>
          <div class="m-team-name m-away-team">
            {{ event.awayTeam }}
          </div>
        </div>

        <!-- live 比赛显示比分 -->
        <MatchScores
          class="m-teams--score"
          :score-of-whole-match="event.scoreOfWholeMatch"
          :score-of-section="event.scoreOfSection"
          :score-in-current-section="event.scoreInCurrentSection"
        />
      </div>

      <div class="m-match-item--footer">
        <!-- 比赛时间 -->
        <div class="m-time m-live-time">
          <span v-if="matchStage">{{ matchStage }}</span>
          <span
            v-if="matchTime"
            class="m-time"
          >{{ matchTime }}</span>
          <span
            v-if="formattedStoppageTime"
            class="m-stoppage-time"
          >{{ formattedStoppageTime }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toRefs } from '@vue/composition-api'
import useMatch from '@ms/components/match/useMatch.js'
import MatchScores from '@ms/components/match/MatchScores.vue'
import { prefillMatchSummary } from '@ms/components/match/useMatchInfo.js'
import { getMatchDetailLink } from '@ms/routes/match'

export default {
  name: 'MatchItem',
  components: {
    MatchScores
  },
  props: {
    event: {
      type: Object,
      default: () => ({})
    },
    currentEventId: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { event } = toRefs(props)

    const { matchTime, formattedStoppageTime, matchStage } = useMatch({ event })

    return {
      matchTime,
      formattedStoppageTime,
      matchStage
    }
  },
  computed: {
    isActive() {
      return this.event.eventId === this.currentEventId
    }
  },
  mounted() {
    if (this.isActive) {
      this.autoScroll()
    }
  },
  methods: {
    handleClick() {
      if (this.isActive) return
      const { event } = this
      prefillMatchSummary(event)
      this.$router.replace(getMatchDetailLink(event))
    },
    autoScroll() {
      const activeMatchEl = this.$refs.activeMatchItem
      const scrollContainer = document.querySelector('.m-detail-match-list.scroll-container')
      if (scrollContainer) {
        scrollContainer.scrollTop = activeMatchEl.offsetTop
      }
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.m-match-item-wrap {
  padding: 0 15/@rem;

  &:last-child {
    .m-match-item {
      border-bottom: 0;
    }
  }

  &.active {
    background: #333;

    .m-match-item {
      border-bottom: 0;
    }
  }
}

.m-match-item {
  padding: 8/@rem 0 6/@rem;
  border-bottom: 1px solid #333;

  .m-teams {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2/@rem 0;
    color: #f8f8f8;
    font-size: 12/@rem;
    line-height: 16/@rem;

    .m-teams--info {
      flex: 1;

      .m-team-name {
        margin-bottom: 2/@rem;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    &--score {
      max-width: 52/@rem;

      .m-score-wrap {
        color: #999;

        .m-score {
          margin-bottom: 2/@rem;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

.m-match-item--footer {
  display: flex;
  height: 14/@rem;
  align-items: center;
  justify-content: flex-start;
  color: #999;
  font-size: 10/@rem;
  line-height: 14/@rem;

  .m-time {
    margin-right: 4/@rem;
    color: @primary;
  }

  .m-stoppage-time {
    color: #999;
  }
}

</style>
